import { useState, useCallback } from 'react';
import { Card, Badge, Space, Typography, Spin, message, Dropdown, Modal } from "antd";
import { FolderOutlined, FileOutlined, DownloadOutlined, MoreOutlined } from "@ant-design/icons";
import FileManagerPOA from '../Poa/FileManagerPOA';
import { fetchPoaData } from '../../services/poa/get_poa';
import { downloadFolder } from '../../services/proyectoEstructurado/proyectoEstructuracionTreeService';
const { Text } = Typography;

export function FolderCard({ item, onClick, isNavigable = true, onUpdateFileCount, onFileUpload, onRefresh }) {
  const canNavigate = isNavigable && item.children && item.children.length > 0;
  const [openModalVisitasEcas, setOpenModalVisitasEcas] = useState(false);
  const [itemParams, setItemParams] = useState(false);
  const [loading, setLoading] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [filesUploaded, setFilesUploaded] = useState(false);

  // ... código anterior del FolderCard ...

  const handleClick = () => {
    if (canNavigate) {
      onClick(item);
    } else {
      // Verificar si no hay carpetas ni archivos
      let banderaCarpetasArchivos = item.dirCount === 0 && item.fileCount === 0;
      const cleanedPath = item.path.replace(/^actividad_13\/tarea_135\//, '');
      procesarMpoa("1.3.5", cleanedPath, banderaCarpetasArchivos);
    }
  };

  // ... resto del código del FolderCard ...

  const handleDownload = async (e) => {
    if (e) {
      e.stopPropagation();
    }

    if (item.type !== "folder") return;

    // Verificar si no hay carpetas ni archivos antes de descargar
    /*if (item.dirCount === 0 && item.fileCount === 0) {
      message.warning('No se puede descargar una carpeta vacía');
      return;
    }*/

    setDownloading(true);
    try {
      const response = await downloadFolder(item.path);
      const blob = new Blob([response], { type: 'application/zip' });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = `${item.name}.zip`;
      document.body.appendChild(link);
      link.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);

      message.success(`Descarga de "${item.name}" iniciada`);
    } catch (error) {
      console.error('Error al descargar la carpeta:', error);
      message.error('Error al descargar la carpeta');
    } finally {
      setDownloading(false);
    }
  };

  const hideModalVisitasEcas = useCallback(() => {
    setOpenModalVisitasEcas(false);
    setItemParams(null);

    // Si se subieron archivos, recargar los contadores
    if (filesUploaded) {
      if (onRefresh) {
        onRefresh(); // Recargar todos los datos
      }
      setFilesUploaded(false); // Resetear el estado
    }
  }, [filesUploaded, onRefresh]);

  const procesarMpoa = async (Mpoa, ruta, banderaCarpetasArchivos) => {
    if (!Mpoa) {
      setOpenModalVisitasEcas(false);
      setItemParams(null);
      setLoading(false);
      return;
    }

    // Verificar si no hay carpetas ni archivos antes de procesar
    /*if (item.dirCount === 0 && item.fileCount === 0) {
      message.warning('No se puede abrir porque no contiene carpetas ni archivos');
      setLoading(false);
      return;
    }*/

    setLoading(true);

    if (Mpoa === '2.2.1') {
      setLoading(false);
      return null;
    }

    const manejarActividadEspecial = (actividad) => {
      switch (actividad) {
        case '2.2.1.1':
        case '2.2.1.2':
        case '2.2.1.3':
          return '2.2.1';
        default:
          return actividad;
      }
    };

    const actividadBase = manejarActividadEspecial(Mpoa);

    try {
      const dataCompleta = await fetchPoaData();
      const dataPoa = dataCompleta.dataPoa;

      const findNodePath = (node, path = []) => {
        path.push(node);
        if (node.codigo_tarea === actividadBase && !['2.2.1.2', '2.2.1.3'].includes(Mpoa)) {
          return path;
        }
        if (['2.2.1.2', '2.2.1.3'].includes(Mpoa)) {
          if (node.children) {
            for (let child of node.children) {
              if (Mpoa === '2.2.1.2' && child.key === 'indicador_33') return [...path, child];
              if (Mpoa === '2.2.1.3' && child.key === 'indicador_34') return [...path, child];
            }
          }
        }

        if (node.children) {
          for (let child of node.children) {
            const result = findNodePath(child, [...path]);
            if (result) return result;
          }
        }
        return null;
      };

      let matchedPath = null;
      for (let nodo of dataPoa) {
        matchedPath = findNodePath(nodo);
        if (matchedPath) break;
      }

      if (matchedPath) {
        const initialData = extractData(matchedPath);
        const actividadData = initialData[0].actividadData;
        const tareaEncontrada = actividadData.find((item) => {
          if (['2.2.1.2', '2.2.1.3'].includes(Mpoa)) {
            return (
              item.codigo_tarea === actividadBase &&
              ((Mpoa === '2.2.1.2' && item.key === 'indicador_33') ||
                (Mpoa === '2.2.1.3' && item.key === 'indicador_34'))
            );
          }
          return item.codigo_tarea === actividadBase;
        });

        if (tareaEncontrada) {
          tareaEncontrada.rutaEstructuracion = ruta;
          tareaEncontrada.banderaCarpetasArchivos = banderaCarpetasArchivos;
          setItemParams(tareaEncontrada);
          setOpenModalVisitasEcas(true);
        } else {
          setOpenModalVisitasEcas(false);
          setItemParams(null);
        }
      } else {
        console.warn("No se encontró ningún nodo coincidente");
      }
    } catch (error) {
      console.error("Error al obtener los datos:", error);
    } finally {
      setLoading(false);
    }
  };

  const extractData = (children) => {
    return children.flatMap(child => {
      if (child.children && child.tipo === 'Actividad') {
        const actividadData = child.children.flatMap(grandchild => {
          if (grandchild.children && grandchild.tipo === 'Tarea') {
            return grandchild.children.flatMap(greatGrandchild => {
              if (greatGrandchild.tipo === 'Indicador') {
                const fecha = greatGrandchild.meta_e?.[0]?.fecha;
                const fechaFormateada = fecha ? new Date(fecha).toLocaleDateString('es-ES') : '-';
                const medioV = greatGrandchild.medioVerificacion || null;
                return {
                  key: greatGrandchild.key,
                  codigo_tarea: grandchild.codigo_tarea,
                  codActividad: grandchild.codActividad,
                  nameActividad: child.actividad,
                  tarea: grandchild.tarea,
                  indicador: greatGrandchild.title,
                  medioV: medioV,
                  fechas: fechaFormateada,
                  responsables: 'N/A',
                  soportes: 'N/A',
                  datoIndicador: greatGrandchild,
                };
              }
              return [];
            });
          }
          return [];
        });
        return [{
          actividadTitle: child.title,
          actividad: child.actividad,
          actividadData: actividadData
        }];
      }
      return [];
    });
  };

  return (
    <>
      <Card
        onClick={handleClick}
        style={{
          height: 110,
          padding: 16,
          cursor: canNavigate ? "pointer" : "default",
          display: "flex",
          flexDirection: "column",
          borderColor: canNavigate ? "#43a1f8ff" : "#f0f0f0",
          position: 'relative',
          // Cambiar el estilo visual si está vacío
          //opacity: (item.dirCount === 0 && item.fileCount === 0) ? 0.6 : 1,
        }}
      >
        {item.type === "folder" && (
          <Dropdown
            menu={{
              items: [
                {
                  key: "download",
                  icon: <DownloadOutlined />,
                  label: 'Descargar carpeta',
                  // Deshabilitar la opción de descarga si está vacía
                  //disabled: item.dirCount === 0 && item.fileCount === 0,
                  onClick: (e) => {
                    e.domEvent.stopPropagation();
                    handleDownload(e.domEvent);
                  }
                }
              ]
            }}
            placement="bottomRight"
            trigger={['click']}
          >
            <span
              style={{
                position: 'absolute',
                top: 8,
                right: 8,
                cursor: 'pointer',
                padding: '4px',
                borderRadius: '4px',
                zIndex: 1,
                // Cambiar el color si está vacío
                color: (item.dirCount === 0 && item.fileCount === 0) ? '#ccc' : '#1890ff',
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <MoreOutlined style={{ fontSize: '16px' }} />
            </span>
          </Dropdown>
        )}

        <Space align="start" style={{ width: "100%" }}>
          {item.type === "folder" ? (
            <FolderOutlined style={{
              fontSize: 32,
              // Cambiar el color si está vacío
              //color: (item.dirCount === 0 && item.fileCount === 0) ? '#ccc' : '#1890ff'
            }} />
          ) : (
            <FileOutlined style={{ fontSize: 32, color: "#8c8c8c" }} />
          )}
          <div style={{ flex: 1, minWidth: 0 }}>
            <Text
              strong
              style={{
                whiteSpace: "normal",
                wordWrap: "break-word",
                wordBreak: "break-word",
                overflowWrap: "break-word",
                display: "block",
                maxWidth: "95%",
                // Cambiar el color si está vacío
                //color: (item.dirCount === 0 && item.fileCount === 0) ? '#999' : 'inherit',
              }}
            >
              {item.viewName || item.name}
            </Text>

            <Space style={{ paddingTop: 10, paddingRight: 5 }}>
              <Badge
                count={`${item.dirCount.toLocaleString()} carpetas`}
                style={{

                  backgroundColor: "#fac840ff", // Azul para carpetas
                  color: "#fff", // Texto blanco para mejor contraste
                  //opacity: item.dirCount === 0 ? 0.5 : 1
                }}
              />
            </Space>

            <Space style={{ paddingTop: 10, paddingLeft: 5 }}>
              <Badge
                count={`${item.fileCount.toLocaleString()} archivos`}
                style={{
                  backgroundColor: "#52c41a", // Verde para archivos
                  color: "#fff", // Texto blanco para mejor contraste
                  opacity: item.fileCount === 0 ? 0.5 : 1
                }}
              />
            </Space>
            {item.typeS && (
              <Badge
                count={item.typeS}
                style={{ backgroundColor: "#fff", border: "1px solid #d9d9d9", color: "#000" }}
              />
            )}
          </div>
        </Space>
      </Card>

      {/* Modal de descarga con spinner */}
      <Modal
        open={downloading}
        footer={null}
        closable={false}
        destroyOnHidden
        centered
        width={300}
        style={{ textAlign: 'center' }}
      >
        <Spin size="large" />
        <div style={{ marginTop: 16 }}>Descargando carpeta...</div>
      </Modal>

      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <Spin tip="Cargando..." size="large" />
        </div>
      )}
      {/* Modal */}
      {openModalVisitasEcas && !loading && (
        <FileManagerPOA
          codigo_tarea={{ codigo_tarea: itemParams }}
          onClose={hideModalVisitasEcas}
        />
      )}
    </>
  );
}